import React from "react";
import "../styles/Empty.css";

export default function Empty() {
  return <div className="empty"></div>;
}
